// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1kDHW","label":"Category_label__37mFA","content":"Category_content__Q_n5K","header":"Category_header__13FZa","location":"Category_location__3fxZB"};